export default "__VITE_ASSET__DyKrOOt4__"